import { createFileRoute } from '@tanstack/react-router'
import TransferHistoryScreen from './-components/screen'
import { pharmacyClient } from '@/connect'
import {z} from 'zod'
import { Loading } from '@/layouts/loading'
import { TransferHistoryStatus } from '@/gen/inventory/common_pb'
const Params = z.object({
  pageNumber: z.number().default(1),
  pageSize: z.number().default(10),
  status: z.enum(['all', 'pending_approval', 'approved', 'rejected', 'cancelled', 'completed']).default('all'),
})
type Params = z.infer<typeof Params>
export const Route = createFileRoute('/(pharma)/_layout/inventory/transfer-history/')({
  component: TransferHistoryScreen,
  validateSearch: Params,
  loaderDeps: ({ search: {pageNumber, pageSize, status} }) => ({
    pageNumber,
    pageSize,
    status
  }),
  loader: async (params) => {

    let finalStatus: TransferHistoryStatus = TransferHistoryStatus.UNSPECIFIED
    if (params.deps.status === 'all') {
      finalStatus = TransferHistoryStatus.UNSPECIFIED
    } else if (params.deps.status === 'pending_approval') {
      finalStatus = TransferHistoryStatus.PENDING_APPROVAL
    } else if (params.deps.status === 'approved') {
      finalStatus = TransferHistoryStatus.APPROVED
    } else if (params.deps.status === 'rejected') {
      finalStatus = TransferHistoryStatus.REJECTED
    } else if (params.deps.status === 'cancelled') {
      finalStatus = TransferHistoryStatus.CANCELLED
    } else if (params.deps.status === 'completed') {
      finalStatus = TransferHistoryStatus.COMPLETED
    } else {
      throw new Error('Invalid status')
    }

    const history = await pharmacyClient.transferHistory({
      pageNumber: params.deps.pageNumber,
      pageSize: params.deps.pageSize,
      status: finalStatus,
    })

    return history
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
})